import React, {
  useEffect
} from 'react';
import { triggerNewRelic, mkTelemetryField } from '../utils/helpers';
import { newRelicConstants } from '../core/constants';

export const useDiscoveryZoneCarouselTelemetry = (props) => {
  const { products } = props;

  /**
   * IMPRESSION
   *
   * Triggers product-pod 'impression' event to NewRelic by listening to the
   * LIFE_CYCLE_EVENT_BUS.
   */
  useEffect(() => {
    // check
    if (!products?.length) return undefined;
    if (!products.some(p => p?.info?.isSponsored)) return undefined;

    const handler = ({ output }) => {

      const { impression, container } = output;

      // check
      if (container?.component !== 'DiscoveryZones') return;
      if (impression?.component !== 'ProductPod') return;

      const product = products.find((item) => item.itemId === impression?.id);
      if (!product?.info?.isSponsored) return;

      // ---
      const value1 = mkTelemetryField({ key: 'itemId', value: impression?.id });
      const value2 = mkTelemetryField({ key: 'trackSource', value: impression?.trackSource });
      const value3 = mkTelemetryField({ key: 'position', value: impression?.position });
      const value4 = mkTelemetryField({ key: 'slotId', value: impression?.slotId });
      const telemetryFields = `${value1}-${value2}-${value3}-${value4}`;
      // ---

      const kpiName = `${newRelicConstants.SPONSORED_DISCOVERY_ZONE_CAROUSEL}-${telemetryFields}`;
      const kpiValue = newRelicConstants.IMPRESSION;

      triggerNewRelic(kpiName, kpiValue);
    };

    // install
    window.LIFE_CYCLE_EVENT_BUS.on('impression.trigger', handler);

    // uninstall
    return () => {
      window.LIFE_CYCLE_EVENT_BUS.off('impression.trigger', handler);
    };
  }, [products]);

};
